import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import ActionBar from '../../Components/Button/ActionBar';
import StoryDetails from '../../Components/Forms/StoryDetails';
import Delete from '../../Components/Button/Delete';
import LongStoryForm from '../../Components/Forms/LongStoryForm';
import SEOForm from '../../Components/Forms/SEOForm';
import { toast } from 'sonner';

export default function ShortStory() {
    const location = useLocation();
    const id = location.state && location.state.id;
    const [category, setCategory] = useState('');
    const [sub_category, setSubCategory] = useState('');
    const [title, setTitle] = useState('');
    const [seo_title, setSeo_Title] = useState('');
    const [description, setDescription] = useState('');
    const [body, setBody] = useState('');
    const [sub_head, setSubHead] = useState('');
    const [photo_by, setPhotoBy] = useState('');
    const [image, setImage] = useState<File | null>(null);
    const [item, setItem] = useState<any | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [role, setRole] = useState<string | null>(null);
    const [createdAt, setCreatedAt] = useState<string | null>(null);
    const [updatedAt, setUpdatedAt] = useState<string | null>(null);

    useEffect(() => {
        if (id) {
            fetchItem(id);
        }
    }, [id]);

    const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setCategory(e.target.value);
    };

    const handleSubCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSubCategory(e.target.value);
    };

    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTitle(e.target.value);
    };

    const handleSeoTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSeo_Title(e.target.value);
    };

    const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescription(e.target.value);
    };

    const handleBodyChange = (content: string) => {
        setBody(content);
    };

    const handleSubHeadChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSubHead(e.target.value);
    };

    const handlePhotoByChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPhotoBy(e.target.value);
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage(e.target.files[0]);
        }
    };

    const navigate = useNavigate();

    const fetchItem = async (id: number) => {
        try {
            const response = await axios.get(`https://cdn.pulp.ph/api/v1/long-stories/${id}`);
            const longStory = response.data.longStory;

            if (longStory) {
                const { category, sub_category, title, body, seo_title, description, sub_head, photo_by, created_at, updated_at, image } = longStory;
                setItem(longStory);
                setSubCategory(sub_category);
                setCategory(category);
                setTitle(title);
                setBody(body);
                setSeo_Title(seo_title);
                setDescription(description);
                setSubHead(sub_head);
                setPhotoBy(photo_by);
                setCreatedAt(created_at);
                setUpdatedAt(updated_at);
                setImage(image);
                console.log(longStory.image);
            }
        } catch (error) {
            console.error('Error fetching item:', error);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formData = new FormData();
        formData.append('category', category);
        formData.append('sub_category', sub_category);
        formData.append('title', title);
        formData.append('body', body);
        formData.append('seo_title', seo_title);
        formData.append('description', description);
        formData.append('sub_head', sub_head);
        formData.append('photo_by', photo_by);

        if (image) {
            formData.append('image', image);
        }

        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                toast.error(<p className="text-[16px]">Authentication token not found!</p>, {
                    duration: 1500,
                });
                
                setIsSubmitting(false);
                return;
            }

            await axios.post(`https://cdn.pulp.ph/api/v1/longStory/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                }
            });

            toast.success(<p className="text-[16px]">Content was submitted successfully!</p>, {
                duration: 1500,
            });

            setTimeout(() => {
                navigate('/view/post/longStory');
            }, 1600);
        } catch (error) {
            console.error('There was an error submitting the form!', error);

            toast.error(<p className="text-[16px]">There was an error submitting the form!</p>, {
                duration: 1500,
            });
        } finally {
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        }
    };

    const handleSaveDraft = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSaved(true);

        const formData = new FormData();
        formData.append('category', category);
        formData.append('sub_category', sub_category);
        formData.append('title', title);
        formData.append('body', body);
        formData.append('seo_title', seo_title);
        formData.append('description', description);
        formData.append('sub_head', sub_head);
        formData.append('photo_by', photo_by);

        if (image) {
            formData.append('image', image);
        }

        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                toast.error(<p className="text-[16px]">Authentication token not found!</p>, {
                    duration: 1500,
                });

                setIsSubmitting(false);
                return;
            }

            await axios.post(`https://cdn.pulp.ph/api/v1/longStory/save/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                }
            });

            toast.success(<p className="text-[16px]">Draft was saved successfully!</p>, {
                duration: 1500,
            });

            setTimeout(() => {
                navigate('/view/post/longStory');
            }, 1600);
        } catch (error) {
            console.error('There was an error submitting the form!', error);

            toast.error(<p className="text-[16px]">There was an error saving the draft!</p>, {
                duration: 1500,
            });
        } finally {
            setTimeout(() => {
                setIsSaved(false);
            }, 3000);
        }
    };

    const handleDelete = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                toast.error(<p className="text-[16px]">Authentication token not found!</p>, {
                    duration: 1500,
                });

                return;
            }

            const confirmDelete = window.confirm('Are you sure you want to delete this content?');
            if (!confirmDelete) {
                return; 
            }

            if (id) {
                await axios.delete(`https://cdn.pulp.ph/api/v1/longStory/${id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    }
                })
            };

            toast.success(<p className="text-[16px]">Content was deleted successfully!</p>, {
                duration: 1500,
            });

            setTimeout(() => {
                navigate('/view/post/longStory');
            }, 1600);
        } catch (error) {
            console.error('There was an error deleting the content!', error);
            
            toast.error(<p className="text-[16px]">There was an error deleting the content!</p>, {
                duration: 1500,
            });
        }
    };

    const handleViewLongStory = () => {
        window.open(`https://pulpmagazine.com/article/long_story/${id}`, '_blank');
    };

    useEffect(() => {
        const storedRole = localStorage.getItem('role');
        setRole(storedRole);
    }, []);

    return (
        <>
            <div className="w-full p-5">
                <div className="flex justify-between items-center mb-4">
                    <h1 className="GraphikSemibold text-[20px]">Long Story Editor</h1>
                    <ActionBar
                        role={role}
                        onSave={handleSaveDraft}
                        onSubmit={handleSubmit}
                        onView={handleViewLongStory}
                        isSubmitting={isSubmitting}
                        isSaved={isSubmitting}
                    />
                </div>

                <div className="bg-white rounded py-5 px-4">
                    <LongStoryForm
                        category={category}
                        sub_category={sub_category}
                        title={title}
                        sub_head={sub_head}
                        body={body}
                        image={image}
                        onCategoryChange={handleCategoryChange}
                        onSubCategoryChange={handleSubCategoryChange}
                        onTitleChange={handleTitleChange}
                        onSubHeadChange={handleSubHeadChange}
                        onBodyChange={handleBodyChange}
                        onImageChange={handleImageChange}
                    />

                    {(role === 'Magazine' || role === 'IT') && (
                        <SEOForm
                            seo_title={seo_title}
                            description={description}
                            onSeoTitleChange={handleSeoTitleChange}
                            onDescriptionChange={handleDescriptionChange}
                        />
                    )}

                    <div className='w-full border-1 border-gray rounded mb-4'></div>

                    <StoryDetails
                        createdAt={createdAt} 
                        updatedAt={updatedAt} 
                    />
                    
                    <Delete onDelete={handleDelete} />
                </div>
            </div>
        </>
    );
}
